const environment = () => {
  return process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV;
}

const backendURL = () => {
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL
  }
  if (environment() === "development") {
    return 'http://localhost:3000/api/v1'
  }
  if (environment() === "staging") {
    return ''
  }
  if (environment() === "production") {
    return 'https://breakwater-api-49b9136490b9.herokuapp.com/api/v1'
  }
}

const apiKeyEncryptionSecret = () => {
  return process.env.REACT_APP_ADMIN_API_KEY_ENCRYPTION_SECRET
}

const adminApiKey = () => {
  return process.env.REACT_APP_ADMIN_API_KEY
}

console.log("environment", environment());
console.log("backendURL", backendURL());

export const ENVIRONMENT = environment();
export const BACKEND_URL = backendURL();
export const ADMIN_API_KEY_ENCRYPTION_SECRET = apiKeyEncryptionSecret();
export const ADMIN_API_KEY = adminApiKey();

